module.exports = __webpack_public_path__ + "static/media/monitoring4.1b569a50.png";